var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useContext, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { Box, Button, Drawer, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";
import { List, TextField, useDelete, DatagridConfigurable, useRefresh, WrapperField, Button as ReactAdminButton, } from "react-admin";
import { IPermissions } from "@/types/keycloak";
import { ListActions } from "@/components/ListActions";
import UploadIcon from "@mui/icons-material/Upload";
import { ActionsColumn } from "@/components/ActionButons";
import { AuthContext } from "@/providers/AuthContextProvider";
import { Dialog, IconButton } from "@sequentech/ui-essentials";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { TemplateCreate } from "./TemplateCreate";
import { CustomApolloContextProvider } from "@/providers/ApolloContextProvider";
import ElectionHeader from "@/components/ElectionHeader";
import { ResourceListStyles } from "@/components/styles/ResourceListStyles";
import { TemplateEdit } from "./TemplateEdit";
import { useMutation } from "@apollo/client";
import { EXPORT_TEMPLATE } from "@/queries/ExportTemplate";
import { DownloadDocument } from "../User/DownloadDocument";
import { ImportDataDrawer } from "@/components/election-event/import-data/ImportDataDrawer";
import { IMPORT_TEMPLATES } from "@/queries/ImportTemplate";
import { useWidgetStore } from "@/providers/WidgetsContextProvider";
import { ETasksExecution } from "@/types/tasksExecution";
import { ThreeStateDatagridHeader } from "@/components/ThreeStateDatagridHeader";
var TemplateEmpty = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    width: 100%;\n"], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    width: 100%;\n"])));
var useActionPermissions = function () {
    var tenantId = useTenantStore()[0];
    var authContext = useContext(AuthContext);
    var canWriteTenant = authContext.isAuthorized(true, tenantId, IPermissions.TENANT_WRITE);
    return {
        canWriteTenant: canWriteTenant,
    };
};
var OMIT_FIELDS = ["id"];
var Filters = [];
export var TemplateList = function () {
    var t = useTranslation().t;
    var deleteOne = useDelete()[0];
    var canWriteTenant = useActionPermissions().canWriteTenant;
    var authContext = useContext(AuthContext);
    var tenantId = useTenantStore()[0];
    var templateRead = authContext.isAuthorized(true, tenantId, IPermissions.template_READ);
    var templateWrite = authContext.isAuthorized(true, tenantId, IPermissions.template_WRITE);
    var _a = useState(false), openExport = _a[0], setOpenExport = _a[1];
    var _b = useState(false), exporting = _b[0], setExporting = _b[1];
    var _c = useState(), exportDocumentId = _c[0], setExportDocumentId = _c[1];
    var _d = useState(false), openImportDrawer = _d[0], setOpenImportDrawer = _d[1];
    var _e = React.useState(false), openDeleteModal = _e[0], setOpenDeleteModal = _e[1];
    var _f = React.useState(), deleteId = _f[0], setDeleteId = _f[1];
    var _g = React.useState(false), openDrawer = _g[0], setOpenDrawer = _g[1];
    var _h = React.useState(undefined), recordId = _h[0], setRecordId = _h[1];
    var ExportTemplate = useMutation(EXPORT_TEMPLATE)[0];
    var ImportTemplate = useMutation(IMPORT_TEMPLATES)[0];
    var _j = useWidgetStore(), addWidget = _j[0], setWidgetTaskId = _j[1], updateWidgetFail = _j[2];
    var refresh = useRefresh();
    var handleExport = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setExporting(false);
            setExportDocumentId(undefined);
            setOpenExport(true);
            return [2 /*return*/];
        });
    }); };
    var confirmExportAction = function () { return __awaiter(void 0, void 0, void 0, function () {
        var currWidget, _a, data, errors, documentId, taskId, error_1;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    currWidget = addWidget(ETasksExecution.EXPORT_TEMPLATES, undefined);
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    setExporting(true);
                    setOpenExport(false);
                    return [4 /*yield*/, ExportTemplate({ variables: { tenantId: tenantId } })];
                case 2:
                    _a = _e.sent(), data = _a.data, errors = _a.errors;
                    if (errors) {
                        setExporting(false);
                        updateWidgetFail(currWidget.identifier);
                        return [2 /*return*/];
                    }
                    documentId = (_b = data === null || data === void 0 ? void 0 : data.export_template) === null || _b === void 0 ? void 0 : _b.document_id;
                    taskId = (_d = (_c = data === null || data === void 0 ? void 0 : data.export_template) === null || _c === void 0 ? void 0 : _c.task_execution) === null || _d === void 0 ? void 0 : _d.id;
                    setExportDocumentId(documentId);
                    setWidgetTaskId(currWidget.identifier, taskId);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _e.sent();
                    console.log(error_1);
                    updateWidgetFail(currWidget.identifier);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleCloseDrawer = function () {
        setOpenDrawer(false);
        refresh();
        setTimeout(function () {
            setRecordId(undefined);
        }, 400);
    };
    var handleImport = function () {
        setOpenImportDrawer(true);
    };
    var handleCreateDrawer = function () {
        setRecordId(undefined);
        setOpenDrawer(true);
    };
    var handleEditDrawer = function (id) {
        setRecordId(id);
        setOpenDrawer(true);
    };
    var deleteAction = function (id) {
        setOpenDeleteModal(true);
        setDeleteId(id);
    };
    var confirmDeleteAction = function () {
        deleteOne("sequent_backend_template", { id: deleteId });
        setDeleteId(undefined);
    };
    var actions = [
        { icon: _jsx(EditIcon, {}), action: handleEditDrawer },
        { icon: _jsx(DeleteIcon, {}), action: deleteAction },
    ];
    var CreateButton = function () { return (_jsxs(Button, { onClick: handleCreateDrawer, children: [_jsx(IconButton, { icon: faPlus, fontSize: "24px" }), t("template.action.createOne")] })); };
    var handleImportTemplates = function (documentId, sha256) { return __awaiter(void 0, void 0, void 0, function () {
        var currWidget, _a, data, errors, taskId, err_1;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    setOpenImportDrawer(false);
                    currWidget = addWidget(ETasksExecution.IMPORT_TEMPLATES, undefined);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, ImportTemplate({
                            variables: {
                                tenantId: tenantId,
                                documentId: documentId,
                                sha256: sha256,
                            },
                        })];
                case 2:
                    _a = _d.sent(), data = _a.data, errors = _a.errors;
                    if (errors) {
                        updateWidgetFail(currWidget.identifier);
                        return [2 /*return*/];
                    }
                    taskId = (_c = (_b = data === null || data === void 0 ? void 0 : data.import_templates) === null || _b === void 0 ? void 0 : _b.task_execution) === null || _c === void 0 ? void 0 : _c.id;
                    setWidgetTaskId(currWidget.identifier, taskId);
                    refresh();
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _d.sent();
                    console.log(err_1);
                    updateWidgetFail(currWidget.identifier);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var Empty = function () { return (_jsxs(TemplateEmpty, { m: 1, children: [_jsx(Typography, { variant: "h4", paragraph: true, children: t("template.empty.title") }), templateWrite ? (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "body1", paragraph: true, children: t("template.empty.subtitle") }), _jsxs(ResourceListStyles.EmptyButtonList, { children: [_jsx(CreateButton, {}), _jsx(ReactAdminButton, { onClick: handleImport, label: String(t("common.label.import")), children: _jsx(UploadIcon, {}) })] })] })) : null] })); };
    var showTemplatesMenu = authContext.isAuthorized(true, tenantId, IPermissions.TEMPLATES_MENU);
    if (!templateRead || !showTemplatesMenu) {
        return (_jsx(ResourceListStyles.EmptyBox, { children: _jsx(Typography, { variant: "h4", paragraph: true, children: t("template.noPermissions") }) }));
    }
    if (!canWriteTenant) {
        return _jsx(Empty, {});
    }
    return (_jsxs(_Fragment, { children: [_jsx(ElectionHeader, { title: String(t("template.title")), subtitle: String(t("template.subtitle")) }), _jsx(List, { resource: "sequent_backend_template", filters: Filters, actions: _jsx(ListActions, { custom: true, withFilter: true, doImport: handleImport, withExport: true, doExport: handleExport, withImport: true, open: openDrawer, setOpen: setOpenDrawer, Component: _jsx(TemplateCreate, { close: handleCloseDrawer }), withComponent: templateWrite }), empty: _jsx(Empty, {}), children: _jsxs(DatagridConfigurable, { header: ThreeStateDatagridHeader, omit: OMIT_FIELDS, children: [_jsx(TextField, { source: "id" }), _jsx(TextField, { source: "template.alias", label: "Alias", sortable: false }), _jsx(TextField, { source: "template.name", label: "Name", sortable: false }), _jsx(TextField, { source: "type" }), _jsx(WrapperField, { source: "actions", label: "Actions", children: _jsx(ActionsColumn, { actions: actions }) })] }) }), _jsx(Drawer, { anchor: "right", open: openDrawer, onClose: handleCloseDrawer, PaperProps: {
                    sx: { width: "40%" },
                }, children: recordId ? (_jsx(TemplateEdit, { id: recordId, close: handleCloseDrawer })) : (_jsx(CustomApolloContextProvider, { role: IPermissions.template_WRITE, children: _jsx(TemplateCreate, { close: handleCloseDrawer }) })) }), _jsx(Dialog, { variant: "warning", open: openDeleteModal, ok: String(t("common.label.delete")), cancel: String(t("common.label.cancel")), title: String(t("common.label.warning")), handleClose: function (result) {
                    if (result) {
                        confirmDeleteAction();
                    }
                    setOpenDeleteModal(false);
                }, children: t("common.message.delete") }), _jsx(Dialog, { variant: "info", open: openExport, ok: String(t("common.label.export")), okEnabled: function () { return !exporting; }, cancel: String(t("common.label.cancel")), title: String(t("common.label.export")), handleClose: function (result) {
                    if (result) {
                        confirmExportAction();
                    }
                    else {
                        setExportDocumentId(undefined);
                        setExporting(false);
                        setOpenExport(false);
                    }
                }, children: t("common.export") }), exporting && exportDocumentId ? (_jsx(DownloadDocument, { documentId: exportDocumentId, fileName: "templates-export.csv", onDownload: function () {
                    console.log("onDownload called");
                    setExportDocumentId(undefined);
                    setExporting(false);
                    setOpenExport(false);
                } })) : null, _jsx(ImportDataDrawer, { open: openImportDrawer, closeDrawer: function () { return setOpenImportDrawer(false); }, title: "template.import.title", subtitle: "template.import.subtitle", paragraph: "template.import.paragraph", doImport: handleImportTemplates, errors: null })] }));
};
var templateObject_1;
